import { render, staticRenderFns } from "./ExpansionCard.vue?vue&type=template&id=5b3b572c&scoped=true&"
import script from "./ExpansionCard.vue?vue&type=script&lang=ts&"
export * from "./ExpansionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExpansionCard.vue?vue&type=style&index=0&id=5b3b572c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b572c",
  null
  
)

export default component.exports